import { useAtomValue } from 'jotai'
import { metadataChannelAtom } from '@/atoms/invalidation'
import client from '@/services/client.service'
import { loadNostrUser, bareNostrUser, NostrUser } from '@nostr/gadgets/metadata'
import { useEffect, useState } from 'react'
import { useCurrentProfile } from '@/atoms/profile'
import { resolveProfileInput } from '@/lib/pubkey'

export function useFetchProfile(input?: string) {
  const currentAccountProfile = useCurrentProfile()
  const channel = useAtomValue(metadataChannelAtom)

  const [isFetching, setIsFetching] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const [profile, setProfile] = useState<NostrUser | null>(null)
  const bare = input ? bareNostrUser(input) : undefined
  const resolvedProfile = bare && profile?.pubkey === bare.pubkey ? profile : null

  useEffect(() => {
    if (!input) {
      setProfile(null)
      setIsFetching(false)
      setError(new Error('No input provided'))
      return
    }

    setError(null)
    setProfile(null)

    if (currentAccountProfile && bare?.pubkey === currentAccountProfile.pubkey) {
      setProfile(currentAccountProfile)
      setIsFetching(false)
      return
    }

    setIsFetching(true)
    ;(async () => {
      try {
        const req = await resolveProfileInput(input)
        const profile = await loadNostrUser(req)
        if (profile) {
          client.addUsernameToIndex(profile)
          setProfile(profile)
        }
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsFetching(false)
      }
    })()
  }, [input, currentAccountProfile, channel])

  return { isFetching, error, profile: resolvedProfile ?? bare }
}
